import { Language } from 'types/language'
import dayjs from 'dayjs'
import { AvailabilityOverride } from './types'

export const DAY_OF_WEEK = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6
} as const

export const AVAILABILITY_OVERRIDES: AvailabilityOverride[] = [
  // Temporary FR override due to low FR care team availability (sick leave)
  {
    start: dayjs('2026-03-24').startOf('day'),
    end: dayjs('2026-03-24').endOf('week'),
    dayOfWeek: [DAY_OF_WEEK.monday, DAY_OF_WEEK.tuesday, DAY_OF_WEEK.wednesday, DAY_OF_WEEK.thursday, DAY_OF_WEEK.friday], // Thursday and Friday
    message: {
      [Language.FRENCH]: "Aujourd'hui, nous sommes joignables jusqu'à 16h"
    }
  }
  // Technical problems
  // {
  //   start: dayjs('2026-09-16').startOf('day'),
  //   end: dayjs('2026-09-16').endOf('week'),
  //   message: {
  //     [Language.DUTCH]: 'Wij zijn tijdelijk telefonisch niet bereikbaar door technische problemen.',
  //     [Language.FRENCH]: 'Nous sommes temporairement injoignables par téléphone en raison de problèmes techniques.'
  //   }
  // }
]
